/*
 * Carissima model-name search.
 * Injects matching elegant model names (custom.display_name) into Dawn's
 * predictive-search dropdown, linking straight to the exact variant URL.
 * Data source: #carissima-model-index (emitted by snippets/carissima-model-search.liquid).
 */
(function () {
  var el = document.getElementById('carissima-model-index');
  if (!el) return;
  var MODELS;
  try {
    MODELS = JSON.parse(el.textContent || '[]');
  } catch (e) {
    return;
  }
  if (!MODELS || !MODELS.length) return;
  for (var i = 0; i < MODELS.length; i++) MODELS[i]._n = (MODELS[i].n || '').toLowerCase();

  var MAX = 6;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function findMatches(raw) {
    var q = raw.trim().toLowerCase();
    if (q.length < 2) return [];
    var starts = [];
    var contains = [];
    for (var i = 0; i < MODELS.length; i++) {
      var idx = MODELS[i]._n.indexOf(q);
      if (idx === 0) {
        if (starts.length < MAX) starts.push(MODELS[i]);
      } else if (idx > 0) {
        if (contains.length < MAX) contains.push(MODELS[i]);
      }
      if (starts.length >= MAX) break;
    }
    return starts.concat(contains).slice(0, MAX);
  }

  function buildGroup(list, nq) {
    var group = document.createElement('div');
    group.className = 'predictive-search__result-group ccmodel-group';
    group.setAttribute('data-ccmodel-q', nq);

    var h2 = document.createElement('h2');
    h2.className = 'predictive-search__heading caption-with-letter-spacing';
    h2.textContent = 'Models';
    group.appendChild(h2);

    var ul = document.createElement('ul');
    ul.className = 'predictive-search__results-list list-unstyled';
    ul.setAttribute('role', 'group');
    ul.setAttribute('aria-label', 'Models');

    list.forEach(function (m, i) {
      var li = document.createElement('li');
      li.className = 'predictive-search__list-item';
      li.id = 'predictive-search-option-ccmodel-' + (i + 1);
      li.setAttribute('role', 'option');
      li.setAttribute('aria-selected', 'false');
      var thumb = m.i
        ? '<span class="ccmodel-thumb" style="background-image:url(' + esc(m.i) + ')"></span>'
        : '<span class="ccmodel-thumb ccmodel-thumb--empty"></span>';
      li.innerHTML =
        '<a href="' +
        esc(m.u) +
        '" class="predictive-search__item link link--text ccmodel-link" tabindex="-1">' +
        thumb +
        '<span class="ccmodel-text">' +
        '<span class="ccmodel-name">' +
        esc(m.n) +
        '</span>' +
        '<span class="ccmodel-sub">' +
        esc(m.p) +
        '</span>' +
        '</span></a>';
      ul.appendChild(li);
    });
    group.appendChild(ul);
    return group;
  }

  function update(container, raw) {
    var root = container.querySelector('#predictive-search-results');
    if (!root) return; // Dawn hasn't rendered results yet; observer will re-fire when it does
    var nq = raw.trim().toLowerCase();
    var existing = root.querySelector('.ccmodel-group');
    if (existing && existing.getAttribute('data-ccmodel-q') === nq) return; // already current
    var list = nq.length >= 2 ? findMatches(raw) : [];
    if (existing) existing.remove();
    if (!list.length) return;
    root.insertBefore(buildGroup(list, nq), root.firstChild);
  }

  function hook(ps) {
    var input = ps.querySelector('input[name="q"]');
    var container = ps.querySelector('[data-predictive-search]');
    if (!input || !container) return;

    var obs = new MutationObserver(function () {
      obs.disconnect();
      update(container, input.value || '');
      obs.observe(container, { childList: true, subtree: true });
    });
    obs.observe(container, { childList: true, subtree: true });

    input.addEventListener('input', function () {
      obs.disconnect();
      update(container, input.value || '');
      obs.observe(container, { childList: true, subtree: true });
    });
  }

  function init() {
    var list = document.querySelectorAll('predictive-search');
    for (var i = 0; i < list.length; i++) hook(list[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
